<script lang="ts" setup>
import { useI18n } from "vue-i18n";
// Section 1 Imports"
import animation1Video from "@/assets/videos/vtcTaxi/Animation1.mp4";
import animation1Img from "@/assets/img/vtcTaxi/Animation1.png";
import animation2Video from "@/assets/videos/vtcTaxi/Animation2.mp4";
import animation2Img from "@/assets/img/vtcTaxi/Animation2.png";
import icon from "@/assets/img/home/services/professional/multi-risk-pro.svg";

// Section 2 Imports"
import moneyIcon from "@/assets/img/ui-insurance/money.png";
import walkingIcon from "@/assets/img/ui-insurance/walkingMan.png";
import standingManIcon from "@/assets/img/ui-insurance/standingMan.png";

// Section 4 Imports"
import multiriskproVideo from "@/assets/videos/home/services/professional/multiriskpro.mp4";
import multiriskproImg from "@/assets/img/home/services/professional/multi-risk-proBg.png";
import foresightVideo from "@/assets/videos/home/services/professional/foresightPro.mp4";
import foresightImg from "@/assets/img/home/services/professional/eyeProBg.png";
import liabilityVideo from "@/assets/videos/home/services/professional/liability.mp4";
import liabilityImg from "@/assets/img/home/services/professional/liabilityBg.png";
const { t } = useI18n();

const section1Data: {
  title: string;
  url: string;
  subTitle: string;
  button: string;
  icon: string;
  items: {
    video: string;
    bg: string;
  }[];
} = {
  title: t("vtcTaxi.firstSection.title"),
  url: `${import.meta.env.VITE_ASSURANCE_VTC_TAXI_URL}`,
  subTitle: t("vtcTaxi.firstSection.subTitle"),
  button: t("vtcTaxi.firstSection.button"),
  icon: icon,
  items: [
    {
      video: animation1Video,
      bg: animation1Img,
    },
    {
      video: animation2Video,
      bg: animation2Img,
    },
  ],
};
const choseSectionData: {
  center: {
    firstParagraph?: string;
    subTitle?: string;
    list: string[];
    benefits: { icon: string; text: string }[];
  };
} = {
  center: {
    firstParagraph: t("vtcTaxi.choseSection.center.secondParagraph"),
    list: [
      t("vtcTaxi.choseSection.center.list.1"),
      t("vtcTaxi.choseSection.center.list.2"),
      t("vtcTaxi.choseSection.center.list.3"),
    ],
    subTitle: t("vtcTaxi.choseSection.center.subTitle"),
    benefits: [
      {
        icon: moneyIcon,
        text: t("vtcTaxi.choseSection.center.benefits.1"),
      },
      {
        icon: walkingIcon,
        text: t("vtcTaxi.choseSection.center.benefits.2"),
      },
      {
        icon: standingManIcon,
        text: t("vtcTaxi.choseSection.center.benefits.3"),
      },
    ],
  },
};
const questionSectionData: {
  text: string;
  questions: {
    question: string;
    answer: Array<{ type: string; value: string | Array<string> }>;
  }[];
} = {
  text: t("vtcTaxi.questions.text"),
  questions: [
    {
      question: t("vtcTaxi.questions.list.1.question"),
      answer: [
        {
          type: "sentence",
          value: t("vtcTaxi.questions.list.1.answer"),
        },
      ],
    },
    {
      question: t("vtcTaxi.questions.list.2.question"),
      answer: [
        {
          type: "sentence",
          value: t("vtcTaxi.questions.list.2.answer"),
        },
      ],
    },
    {
      question: t("vtcTaxi.questions.list.3.question"),
      answer: [
        {
          type: "sentence",
          value: t("vtcTaxi.questions.list.3.answer"),
        },
      ],
    },
    {
      question: t("vtcTaxi.questions.list.4.question"),
      answer: [
        {
          type: "sentence",
          value: t("vtcTaxi.questions.list.4.answer"),
        },
      ],
    },
    {
      question: t("vtcTaxi.questions.list.5.question"),
      answer: [
        {
          type: "sentence",
          value: t("vtcTaxi.questions.list.5.answer"),
        },
      ],
    },
    {
      question: t("vtcTaxi.questions.list.6.question"),
      answer: [
        {
          type: "sentence",
          value: t("vtcTaxi.questions.list.6.answer"),
        },
      ],
    },
  ],
};
const otherSuggestionsData: {
  video: string;
  bg: string;
  text: string;
  url: string;
  out: boolean;
}[] = [
  {
    text: t("vtcTaxi.otherSuggestions.cards.1"),
    video: multiriskproVideo,
    bg: multiriskproImg,
    out: false,
    url: "/assurances/professionnelles/multirisque-professionnelle/",
  },
  {
    text: t("vtcTaxi.otherSuggestions.cards.2"),
    video: foresightVideo,
    bg: foresightImg,
    out: false,
    url: "/assurances/professionnelles/prevoyance-pro/",
  },
  {
    text: t("vtcTaxi.otherSuggestions.cards.3"),
    video: liabilityVideo,
    bg: liabilityImg,
    url: "/assurances/professionnelles/rc-decennale",
    out: false,
  },
];
</script>
<template>
  <UiServiceDetailSection1 :data="section1Data">
    <template #underTitle>
      {{ t("vtcTaxi.firstSection.underTitle") }}
    </template>
  </UiServiceDetailSection1>
  <UiServiceDetailChoseSection :data="choseSectionData">
    <template #title>
      {{ t("vtcTaxi.choseSection.center.title.part-1") }}<br />
      {{ t("vtcTaxi.choseSection.center.title.part-2") }}
    </template>
    <template #leftParagraph>
      <span class="benefits-span">{{
        $t("vtcTaxi.choseSection.left.paragraph.part-1")
      }}</span>
      {{ $t("vtcTaxi.choseSection.left.paragraph.part-2") }}<br />
      <span class="benefits-span">{{
        $t("vtcTaxi.choseSection.left.paragraph.part-3")
      }}</span>
      {{ $t("vtcTaxi.choseSection.left.paragraph.part-4") }}<br />
      <span class="benefits-span">{{
        $t("vtcTaxi.choseSection.left.paragraph.part-5")
      }}</span>
      {{ $t("vtcTaxi.choseSection.left.paragraph.part-6") }}<br />
      <span class="benefits-span">{{
        $t("vtcTaxi.choseSection.left.paragraph.part-7")
      }}</span>
      {{ $t("vtcTaxi.choseSection.left.paragraph.part-8") }}<br />
      <span class="benefits-span">{{
        $t("vtcTaxi.choseSection.left.paragraph.part-9")
      }}</span>
      {{ $t("vtcTaxi.choseSection.left.paragraph.part-10") }}<br />
    </template>
    <template #rightParagraph>
      <span class="benefits-span">{{
        $t("vtcTaxi.choseSection.right.paragraph.part-1")
      }}</span>
      {{ $t("vtcTaxi.choseSection.right.paragraph.part-2") }}<br />
      <span class="benefits-span">{{
        $t("vtcTaxi.choseSection.right.paragraph.part-3")
      }}</span>
      {{ $t("vtcTaxi.choseSection.right.paragraph.part-4") }}<br />
      <span class="benefits-span">{{
        $t("vtcTaxi.choseSection.right.paragraph.part-5")
      }}</span>
      {{ $t("vtcTaxi.choseSection.right.paragraph.part-6") }}<br />
      <span class="benefits-span">{{
        $t("vtcTaxi.choseSection.right.paragraph.part-7")
      }}</span>
      {{ $t("vtcTaxi.choseSection.right.paragraph.part-8") }}<br />
      <span class="benefits-span">{{
        $t("vtcTaxi.choseSection.right.paragraph.part-9")
      }}</span>
      {{ $t("vtcTaxi.choseSection.right.paragraph.part-10") }}<br />
      <span class="benefits-span">{{
        $t("vtcTaxi.choseSection.right.paragraph.part-11")
      }}</span>
      {{ $t("vtcTaxi.choseSection.right.paragraph.part-12") }}<br />
    </template>
  </UiServiceDetailChoseSection>
  <UiServiceDetailQuestionSection :data="questionSectionData" />
  <UiServiceDetailOtherSuggestions :data="otherSuggestionsData" />
</template>
